export const WORK_ORDER_STATUSES = [
  "idea",
  "planned",
  "in_progress",
  "completed",
  "cancelled",
] as const;
export type WorkOrderStatus = (typeof WORK_ORDER_STATUSES)[number];

/**
 * Statuses whose requirements take part in allocation and to-order amounts
 * (architecture.md › Allocation).
 */
export const ACTIVE_WORK_ORDER_STATUSES = [
  "planned",
  "in_progress",
] as const satisfies readonly WorkOrderStatus[];
export const OPEN_WORK_ORDER_STATUSES = [
  "idea",
  "planned",
  "in_progress",
] as const satisfies readonly WorkOrderStatus[];

export const WORK_ORDER_TYPES = [
  "maintenance",
  "repair",
  "tuning",
  "restoration",
  "roadworthiness_inspection",
  "other",
] as const;
export type WorkOrderType = (typeof WORK_ORDER_TYPES)[number];

/** An online shop, or a local dealer: a counter you visit, which can also order parts for you. */
export const SUPPLIER_KINDS = ["online", "local"] as const;
export type SupplierKind = (typeof SUPPLIER_KINDS)[number];

export const ORDER_STATUSES = [
  "draft",
  "ordered",
  "partially_received",
  "received",
  "cancelled",
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

/** Orders whose open lines count as "on order". */
export const INCOMING_ORDER_STATUSES = [
  "ordered",
  "partially_received",
] as const satisfies readonly OrderStatus[];

export const MOVEMENT_REASONS = [
  "initial",
  "adjustment",
  "order_receipt",
  "work_order_consumption",
  // Taken with the scanner, booked to a work order or to none (ADR 0018).
  "taken",
] as const;
export type MovementReason = (typeof MOVEMENT_REASONS)[number];

export const MILEAGE_UNITS = ["km", "mi"] as const;
export type MileageUnit = (typeof MILEAGE_UNITS)[number];

/** What powers a vehicle; a vehicle may have none set. */
export const DRIVE_TYPES = ["petrol", "diesel", "lpg", "cng", "phev", "bev"] as const;
export type DriveType = (typeof DRIVE_TYPES)[number];

export const OWNER_TYPES = [
  "part",
  "vehicle",
  "work_order",
  "template",
  "order",
  "expense",
] as const;
export type OwnerType = (typeof OWNER_TYPES)[number];

export const ATTACHMENT_KINDS = ["image", "document"] as const;
export type AttachmentKind = (typeof ATTACHMENT_KINDS)[number];

export const AVAILABILITY_STATUSES = ["in_stock", "on_order", "partial", "missing"] as const;
export type AvailabilityStatus = (typeof AVAILABILITY_STATUSES)[number];

export const READINESS_STATUSES = ["ready", "waiting", "missing"] as const;
export type Readiness = (typeof READINESS_STATUSES)[number];
